/**
 * <htw-pick>: picks one look from `data-look-paths` (comma-separated metaobject
 * paths) and fetches just that row's markup via Section Rendering
 * (`?section_id=helper-how-to-wear-it`), so the PDP doesn't ship every look's
 * HTML/images upfront.
 *
 * The trigger href can't be set in the helper section because the anchor
 * product is unknown in the metaobject's scope — we rewrite it here using
 * `data-anchor` from the PDP.
 *
 * `connectedCallback` runs on initial parse AND when a `<product-page>` is
 * swapped in by a combined-listing change, so the new product's looks are
 * picked automatically.
 */
if (!customElements.get('htw-pick')) {
  customElements.define(
    'htw-pick',
    class extends HTMLElement {
      async connectedCallback() {
        if (this._loaded) return;
        this._loaded = true;

        const paths = (this.dataset.lookPaths || '')
          .split(',')
          .map((p) => p.trim())
          .filter(Boolean);
        if (!paths.length) return;

        const slot = this.querySelector('[data-htw-slot]');
        if (!slot) return;

        const anchor = (this.dataset.anchor || '').trim();
        const pick = paths[Math.floor(Math.random() * paths.length)];

        try {
          const res = await fetch(`${pick}?section_id=helper-how-to-wear-it`);
          if (!res.ok) return;
          const html = await res.text();
          const row = new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector('[data-htw-row]');
          if (!row) return;

          row.setAttribute(
            'href',
            anchor
              ? `#trigger:shopTheLook:${anchor}||${pick}`
              : `#trigger:shopTheLook:${pick}`
          );

          slot.replaceChildren(row);
          // Force a reflow so the browser commits the collapsed (0fr) state
          // before the class flips to 1fr — otherwise styles batch and the
          // grid-template-rows transition is skipped.
          void this.offsetHeight;
          this.classList.add('is-revealed');
        } catch {
          /* non-critical enhancement — leave hidden on failure */
        }
      }
    }
  );
}
